// src/pages/Login.jsx
import { useState } from 'react';
import { useAuth, USUARIOS } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [usuarioInput, setUsuarioInput] = useState('');
  const [pin, setPin] = useState('');
  const [paso, setPaso] = useState('usuario');
  const [usuarioEncontrado, setUsuarioEncontrado] = useState(null);
  const [error, setError] = useState('');

  const handleUsuario = (e) => {
    e.preventDefault();
    const found = USUARIOS.find(u => u.usuario === usuarioInput.toLowerCase().trim());
    if (!found) { setError('Usuario no encontrado'); return; }
    setUsuarioEncontrado(found);
    setPaso('pin');
    setError('');
  };

  const handlePin = (valor) => {
    if (pin.length >= 4) return;
    const nuevoPin = pin + valor;
    setPin(nuevoPin);
    if (nuevoPin.length === 4) {
      if (nuevoPin === usuarioEncontrado.pin) {
        login(usuarioEncontrado);
        navigate('/dashboard');
      } else {
        setError('PIN incorrecto');
        setPin('');
      }
    }
  };

  const borrar = () => setPin(pin.slice(0, -1));
  const teclas = ['1','2','3','4','5','6','7','8','9','','0','⌫'];

  return (
    <div style={s.container}>
      <div style={s.card}>
        <h1 style={s.titulo}>🔧 Zoler Admin</h1>

        {paso === 'usuario' ? (
          <form onSubmit={handleUsuario}>
            <p style={s.subtitulo}>Ingresa tu usuario</p>
            <input
              style={s.input}
              value={usuarioInput}
              onChange={e => setUsuarioInput(e.target.value)}
              placeholder="Ej: admin"
              autoFocus
            />
            {error && <p style={s.error}>{error}</p>}
            <button style={s.boton} type="submit">Continuar →</button>
          </form>
        ) : (
          <>
            <p style={s.subtitulo}>Hola, {usuarioEncontrado.nombre}</p>
            <div style={s.puntos}>
              {[0,1,2,3].map(i => (
                <div key={i} style={{...s.punto, ...(pin.length > i ? s.puntoLleno : {})}} />
              ))}
            </div>
            {error && <p style={s.error}>{error}</p>}
            <div style={s.teclado}>
              {teclas.map((t, i) => (
                <button
                  key={i}
                  style={{...s.tecla, ...(t === '' ? s.teclaVacia : {})}}
                  onClick={() => t === '⌫' ? borrar() : t && handlePin(t)}
                >
                  {t}
                </button>
              ))}
            </div>
            <button style={s.link} onClick={() => { setPaso('usuario'); setPin(''); setUsuarioInput(''); }}>
              ← Cambiar usuario
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  container: { minHeight: '100vh', background: '#1a1a2e', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  card: { background: '#2d2d44', borderRadius: 16, padding: 40, width: 320, textAlign: 'center' },
  titulo: { color: '#fff', fontSize: 24, marginBottom: 8 },
  subtitulo: { color: '#aaa', fontSize: 14, marginBottom: 24 },
  input: { width: '100%', background: '#1a1a2e', border: '1px solid #444', borderRadius: 8, padding: '12px 16px', color: '#fff', fontSize: 16, marginBottom: 12, boxSizing: 'border-box' },
  boton: { width: '100%', background: '#e63946', border: 'none', borderRadius: 8, padding: '12px', color: '#fff', fontSize: 16, fontWeight: 'bold', cursor: 'pointer' },
  puntos: { display: 'flex', gap: 16, justifyContent: 'center', marginBottom: 32 },
  punto: { width: 16, height: 16, borderRadius: 8, border: '2px solid #fff' },
  puntoLleno: { background: '#fff' },
  teclado: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 24 },
  tecla: { background: '#1a1a2e', border: 'none', borderRadius: 32, width: 64, height: 64, color: '#fff', fontSize: 22, fontWeight: '600', cursor: 'pointer', margin: 'auto' },
  teclaVacia: { background: 'transparent', cursor: 'default' },
  error: { color: '#e63946', fontSize: 13, marginBottom: 12 },
  link: { background: 'none', border: 'none', color: '#aac4e0', cursor: 'pointer', fontSize: 14 },
};